<li
  class="root"
  [rkDndDropzone]="['track']"
  (dndDrop)="dropped($event)"
  [dndDisableIf]="bac.isLocked || bacPlanLocked() || isActive"
  data-cy="library-root-bac"
>
  <div class="head">
    <a
      class="link"
      [class.locked]="bacPlanLocked()"
      [routerLink]="bacPlanLocked() ? null : ['/radio/' + radioId + '/media/' + bac.url]"
      (click)="clickBac()"
    >
      <mat-icon fontSet="fa" [fontIcon]="bac.icon" class="bac-icon"></mat-icon>
      <span>{{ bac.translated$ | async }}</span>
    </a>
    <div class="toggle-left">
      @if (bacPlanLocked()) {
        <rk-locked-icon
          icon="fa-crown"
          [props]="{ origin: 'library_audio_shoutouts' }"
        ></rk-locked-icon>
      } @else {
        <span class="count">{{ bac.count }}</span>
      }
      <rk-icon-button
        [hidden]="true"
        faIcon="fa-plus"
        [bordered]="true"
        (click)="clickMenu($event)"
      ></rk-icon-button>
    </div>
  </div>
</li>
<div [@slideInOutBlock] *ngIf="isOpen">
  <rk-library-sbac [bacs]="bac.children"></rk-library-sbac>
</div>
